
const digest = 'f0041517e4b71b98267e6e657061db8315bb6f8d1812e9f422d203c5b5796c44';
const classes = {"wrapper":"_wrapper_1e0ux_1","green":"_green_1e0ux_9","orange":"_orange_1e0ux_14","gray":"_gray_1e0ux_19","red":"_red_1e0ux_24"};
const css = `._wrapper_1e0ux_1 {
  font-family: Rubik, sans-serif;
  font-size: 10px;
  font-weight: 500;
  padding: 3px 7px;
  border-radius: 4px;
}

._green_1e0ux_9 {
  background-color: #619612;
  color: #fff;
}

._orange_1e0ux_14 {
  background-color: #f27114;
  color: #fff;
}

._gray_1e0ux_19 {
  background-color: #afb6ca;
  color: #fff;
}

._red_1e0ux_24 {
  background-color: #f12848;
  color: #fff;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  